import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBookmark: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bookmark, banner, flag, tag"><path d="M5.75 2C4.7835 2 4 2.7835 4 3.75V20.2515C4 21.6527 5.56475 22.4857 6.72719 21.7032L11.8604 18.248C11.9448 18.1912 12.0552 18.1912 12.1396 18.248L17.2728 21.7032C18.4353 22.4857 20 21.6527 20 20.2515V3.75C20 2.7835 19.2165 2 18.25 2H5.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBookmark;
